import React, { useState } from "react";
import { default as CustomAxios } from "../axios";
import { toast } from "react-toastify";
import { checkPassValidator } from "../components/PasswordValidator";
import { useNavigate } from "react-router-dom";

function ResetPasswordScreen() {
  const [apiFetching, setApiFetching] = useState(false);
  let navigate = useNavigate();
  // const [token, setToken] = useState("");
  const query = new URLSearchParams(window.location.search);
  const token = query.get("token");
  const handleSubmit = (e) => {
    e.preventDefault();
    const [password, confPassword] = ["password", "confPassword"].map(
      (key) => e.target[key].value
    );
    if (checkPassValidator(password) !== "Success") {
      toast.error(checkPassValidator(password));
    } else if (password !== confPassword) {
      toast.error("Password do not macth");
    } else {
      setApiFetching(true);
      CustomAxios.post(
        "/auth/reset-password",
        { password, token },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then(() => {
          setApiFetching(false);
          e.target.password.value = "";
          e.target.confPassword.value = "";
          toast.success(
            "Password reset successful, login with your new password"
          );
          navigate("/");
        })
        .catch((err) => {
          let data = err.response?.data;
          if (!data?.success) {
            toast.error("Error: " + (data?.error?.message || "Something went wrong"));
            setApiFetching(false);
          }
        });
    }
  };
  return (
    <div className="grid grid-cols-2 gap-10 w-full place-items-center h-[calc(100vh-75px)]  absolute top-[75px]">
      <div className="col-span-1 md:visible hidden w-full h-full md:flex justify-center items-center bg-[#efefef] shadow-lg">
        <img
          className="w-full md:w-[75%] h-full md:object-contain object-cover"
          src="/Images/resetImage.svg"
          alt=""
        />
      </div>
      <div className="col-span-2 md:col-span-1 w-full h-full items-center  bg-white justify-center flex">
        <div className="flex flex-col w-[85%] md:w-[75%] lg:w-[70%]  gap-5">
          {/* Avatar */}
          <div className="flex justify-center  flex-col mb-2 gap-1">
            <h2 className="text-3xl md:text-4xl">
              Reset Password
              {/* <span className="wave text-5xl">🤔</span> */}
            </h2>
            <p className="text-gray-500 font-normal text-sm ml-1">
              After reset, login with the new password
            </p>
            {/* <i className="border-[#dedbf6] p-1 border-4 rounded-full fa-solid fa-circle-user text-6xl text-primary"></i> */}
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="flex flex-col w-full gap-4">
            <div className="flex flex-col gap-2">
              <label className="">Password</label>
              <input
                data-testid="userIdInput"
                className="bg-[#f8f8f8] font-normal border-[2.6px] border-[#efefef] placeholder:text-[#b4b4b4] placeholder:font-normal focus:!ring-primary px-3.5 py-3 rounded-md"
                type="text"
                placeholder="Enter your password"
                name="password"
                required
              />
            </div>

            <div className="flex flex-col gap-2">
              <label className="">Confirm Password</label>
              <input
                data-testid="passInput"
                className="bg-[#f8f8f8] font-normal border-[2.6px] border-[#efefef] placeholder:text-[#b4b4b4] placeholder:font-normal px-3.5 focus:outline-0 py-3 rounded-md"
                type="text"
                placeholder="Enter your confirm password"
                name="confPassword"
                required
              />
            </div>
            {/* LOGIN Buttons */}

            <div className="flex flex-col w-2/5 items-center mx-auto mt-2 gap-3.5">
              <button className="bg-primary text-white px-14 py-2 rounded-md whitespace-nowrap">
                {apiFetching ? "Resetting..." : "Reset"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordScreen;
